import { Link } from "react-router-dom";
import { channels } from "@/mocks/channels";
import { toneClasses } from "@/lib/ui";

export default function ChannelDirectory() {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[760px] border-collapse text-left">
          <caption className="sr-only">51爆料网全部栏目与内容板块入口索引</caption>
          <thead>
            <tr className="bg-background-100 text-xs text-foreground-600">
              <th scope="col" className="px-5 py-3 font-medium">栏目名称</th>
              <th scope="col" className="px-5 py-3 font-medium">所属分组</th>
              <th scope="col" className="px-5 py-3 font-medium">页面位置</th>
              <th scope="col" className="px-5 py-3 font-medium">内容方向</th>
              <th scope="col" className="px-5 py-3 text-right font-medium">入口</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-background-200">
            {channels.map((channel) => {
              const tone = toneClasses[channel.tone];
              return (
                <tr key={channel.slug} className="align-top transition-colors hover:bg-background-100">
                  <td className="px-5 py-4">
                    <div className="flex items-center gap-2.5">
                      <span className={`flex h-8 w-8 items-center justify-center rounded-md ${tone.bgSoft} ${tone.textStrong}`}>
                        <i className={`${channel.icon} text-base`} />
                      </span>
                      <div>
                        <p className="font-heading text-sm font-bold text-foreground-950">{channel.name}</p>
                        <p className="text-xs text-foreground-500">{channel.tagline}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-5 py-4">
                    <span className="rounded bg-background-100 px-2 py-0.5 text-xs text-foreground-600">
                      {channel.group}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-sm text-foreground-700">{channel.position}</td>
                  <td className="max-w-[280px] px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {channel.highlights.join(" · ")}
                  </td>
                  <td className="px-5 py-4 text-right">
                    <Link
                      to={`/pindao/${channel.slug}`}
                      className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
                    >
                      进入板块
                      <i className="ri-arrow-right-line" />
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}